<template>
  <div>
    <label :for="`custom-textarea${title}`">{{ title }}</label>
    <textarea
      :id="`custom-textarea${title}`"
      cols="30"
      :rows="rowsNumber || 10"
      :placeholder="placeholder"
      v-model="currentValue"
      @keyup="(e) => (handleEnterAction ? handleEnterClick(e) : null)"
    ></textarea>
  </div>
</template>

<script>
export default {
  props: ["title", "placeholder", "rowsNumber", "handleEnterAction", "prePick"],
  emits: ["change", "enterClicked"],
  data() {
    return {
      currentValue: this.prePick || "",
    };
  },
  watch: {
    currentValue() {
      this.$emit("change", this.currentValue);
    },
  },
  methods: {
    handleEnterClick(e) {
      if (e.key === "Enter") {
        this.handleEnterAction(this.currentValue);
        this.currentValue = "";
      }
    },
  },
};
</script>

<style scoped>
textarea {
  resize: none;
  width: 100%;
  font-size: 14px;
  border: 1px solid #c1c1cf;
  border-radius: 8px;
  padding: 5px;
}
label {
  display: block;
  font-weight: 700;
  margin-bottom: 5px;
  font-size: 14px;
  color: #090741;
}
</style>
